module.exports = __webpack_public_path__ + "static/img/zzfwb.6f548cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zzfwb.jpg
// module id = IsUX
// module chunks = 73